<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="1200_auto"
      @close="cancel"
      :class="{'noPaddingTop':isDetailed}"
      :footer="false">
    <template #header>
      <gj-breadcrumb v-if="isDetailed" :list="breadcrumbList" @backHandle="isDetailed=false"></gj-breadcrumb>
      <div v-show="!isDetailed">
        <span>模板使用详情</span><span class="modal-secondary-title">{{ item.templateName }}</span>
      </div>
    </template>
    <template #content>

      <detail-content ref="detailContent" v-show="!isDetailed" :item="item" @lookDetailed="lookDetailed" @enable="enable" @pause="pause" @delete="deleteItem"></detail-content>
      <detailed-content
          ref="detailedContent"
          v-if="isDetailed"
          :item="item"
          :detailedItem="detailedItem"
          @back="isDetailed=false"
          @enable="enable" @pause="pause" @delete="deleteItem"
      >
      </detailed-content>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, responseMixin} from "../../../../../../../minxins";

import DetailContent from "./components/detail-content"
import DetailedContent from "./components/detailed-content"
import {AdStrategyEnum} from "@/views/modules/ad/strategy/common/enum";
import {
  getResumeCondition,// 判断是否需要执行还原
  batchUpdateStrategyObject, // 批量修改(移除)广告策略状态
} from "@/api/ad";
import ToolTipBox from "@/views/modules/ad/strategy/time-adjust/modal/tool-tip-box/tool-tip-box";

export default {
  name: "app-strategy-tpl-use-detail-modal",
  mixins: [modalMixIn, responseMixin],
  components: {DetailContent, DetailedContent},
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {
      isDetailed: false,// 是否查看明细
      detailedItem:null,
      breadcrumbList: [
        {
          name: '模板使用详情', handle: () => {
            this.isDetailed = false
          }
        },
        {
          name: '对象明细', handle: function () {
          }
        },
      ],
    }
  },
  methods: {
    lookDetailed(e) {
      this.breadcrumbList[1].name = e.text;
      this.detailedItem = e.detailedItem
      this.isDetailed = true;
    },
    cancel() {
      if (this.updated) {
        this.$emit('updated');
      }
    },
    // 开启
    enable(rows) {
      if(rows.length===0){
        this.$message.warning('请先勾选')
        return
      }
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: "启用确认",
          content: `确认启用分时策略？`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: async () => {
            modal.confirmLoading = true;
            // let data = {}
            // try {
            //   data = await this.isPopupFn(rows, AdStrategyEnum.status.template.ENABLE)
            //   if (data.resume === -1) {
            //     return false
            //   }
            // } finally {
            // modal.$gjDestroy()
            // }
            let param = rows.map(row => {
              return {
                marketId: row.marketId,
                objectPid: row.id,
                objectStatus: AdStrategyEnum.status.template.ENABLE
              }
            })
            await batchUpdateStrategyObject(param)
                .then(() => {
                  this.$gjMessage.success('开启成功，广告分时策略将在下一个生效时段开始生效');
                  if(!this.isDetailed){
                    this.$refs.detailContent.$gjResetPage()
                  }else {
                    this.$refs.detailedContent.$gjResetPage()
                  }
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
          }
        }
      });
    },
    // 暂停
    pause(rows) {
      if(rows.length===0){
        this.$message.warning('请先勾选')
        return
      }
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: "停用确认",
          content: `确认停用分时策略？`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: async () => {
            modal.confirmLoading = true;
            let data = {}
            // try {
            data = await this.isPopupFn(rows, AdStrategyEnum.status.template.PAUSE)
            if (data.resume === -1) {
              modal.$gjDestroy();
              return false
            }
            // } finally {
            // modal.$gjDestroy()
            // }
            let param = rows.map(row => {
              return {
                marketId: row.marketId,
                objectPid: row.id,
                objectStatus: AdStrategyEnum.status.template.PAUSE,
                resumeTaskId: data.resumeTaskId,
                resume: data.resume
              }
            })
            await batchUpdateStrategyObject(param)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    if(!this.isDetailed){
                      this.$refs.detailContent.$gjResetPage()
                    }else {
                      this.$refs.detailedContent.$gjResetPage()
                    }
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
          }
        }
      });
    },
    // 移除
    deleteItem(rows) {
      if(rows.length===0){
        this.$message.warning('请先勾选')
        return
      }
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          content: `确定要删除吗？一旦删除不可恢复，请谨慎操作！`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: async () => {
            modal.confirmLoading = true;
            let data = await this.isPopupFn(rows, AdStrategyEnum.status.template.ARCHIVE)
            if (data.resume === -1) {
              modal.$gjDestroy()
              return false
            }
            let param = rows.map(row => {
              return {
                marketId: row.marketId,
                objectPid: row.id,
                objectStatus: AdStrategyEnum.status.template.ARCHIVE,
                resumeTaskId: data.resumeTaskId,
                resume: data.resume
              }
            })
            await batchUpdateStrategyObject(param)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.updated = true;
                    this.$gjMessage.success('操作成功');
                    if(!this.isDetailed){
                      this.$refs.detailContent.$gjResetPage()
                    }else {
                      this.$refs.detailedContent.$gjResetPage()
                    }
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
          }
        },
      });
    },
    isPopupFn(rows, status) {
      return new Promise(async (resolve, reject) => {
        let params = rows.map(row => {
          return{
            status,
            objectPid: row.id,
            operatingType: 1,
          }
        })
        let data;
        try {
          data = await getResumeCondition(params)
        } catch (error) {
          return false
        }
        if (data && data.length > 0) {
          this.$gjCreate(ToolTipBox, {
            props: {
              msg: '分时调价策略正在生效中，请确认是否需要将预算和竞价恢复到基础预算和竞价',
              data: data
            },
            on: {
              update: (type, resumeTaskId) => {
                resolve({resume: type, resumeTaskId})
              },
              close:()=>{
                resolve({resume: -1})
              }
            }
          });
        } else {
          resolve({resume: false})
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.noPaddingTop {
  /deep/ .el-dialog__body {
    padding-top: 0;
  }
}
/deep/.gj-modal--normal .el-dialog {
  width: 500px !important;
}
</style>

